<div class="col-12 d-flex row justify-content-between header-height pt-3 m-0 pr-5">
  <div>

    <div class="d-flex">
      <img class="logo-height" *ngIf="userType == 'Bridge+'" src="/assets/images/bridgeplus-logo.png" loading="lazy" />
      <img class="logo-height" *ngIf="userType == 'Parkite'" src="/assets/images/capitaland.png" loading="lazy" />
      <img class="place-height pl-4" src="/assets/images/place.png" loading="lazy" />
      <div class="location-text ellipsis pl-2 mt-1 header-place-text">
        <!-- <div class="customerStyle" style="cursor: pointer;">
        <select class="dropdown minimal" *ngIf="parkDetails" (change)="setParkId($event.target.value)">
          <option *ngFor="let park of parkDetails" [value]="park.parkId" [selected]="selectedPark == park.parkId">{{park.parkName}}, {{park.cityName}}</option>
        </select>
        </div> -->
        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" style="display: flex; align-items: center;"
          [ngbPopover]="popContentBuildingName" triggers="manual" #p="ngbPopover" (click)="openPopover(p);"
          placement="bottom" popoverClass='dash-popover dashboard-popover'>
          <p class="pt-3 pb-3 pl-4 mr-2 textbox-style placeholder-text pointer-link dropdown-input">{{displayPark}}</p>
          <!-- <input class="pt-3 pb-3 pl-4 mr-4 textbox-style placeholder-text pointer-link dropdown-input" readonly [(ngModel)]="displayPark"> -->
          <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
        </div>

        <ng-template #popContentBuildingName>
          <div style="overflow-y: scroll !important;
          height: 150px !important;">
            <div class="d-flex justify-content-between">
              <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;margin-right: 15px;">
                <div class="row pb-2 no-wrap-flex" *ngFor="let park of parkDetails;let i =index"
                  (click)="setParkId(park.parkId); openPopover(p)" style="justify-content: space-between;">
                  <div class="popover-content normal-font pl-3 email-width word-wrap">
                    {{park.parkName}}, {{park.cityName}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <!-- <img class="dropdown-size pl-2" src="/assets/images/Path.png" loading="lazy" /> -->
    </div>
  </div>
  <div class="justify-content-end">
    <div class="d-flex header-refreshed-text">
      <div class="userDetails">
        <ul>
          <li>
            Welcome, <span>{{adminName}}</span>
          </li>
          <li>
            {{parkTenantName}}
          </li>
          <li>
            Last refreshed on {{lastRefreshedTime}}
          </li>
        </ul>
      </div>
      <div class="notifyIcon">
        <span class="badge pointer-link" (click)="toggleNotification()">{{notificationCount}}</span>
        <img src="/assets/images/notification.png" class="pointer-link" loading="lazy" (click)="toggleNotification()" />
      </div>
    </div>
   <!--  <div class="d-flex header-refreshed-text">
      <div class="text-left">Last refreshed on {{lastRefreshedTime}}
        <br />
        <div class="text-left">Welcome, {{adminName}}</div>
      </div>
      <div>
        <span class="badge pointer-link" (click)="toggleNotification()">{{notificationCount}}</span>
        <img src="/assets/images/notification.png" class="pointer-link" loading="lazy" (click)="toggleNotification()" />
      </div>
    </div> -->
  </div>
</div>
